const BASE_A4_METRICS = {
  pageWidthPx: 794,
  pageHeightPx: 1123,
  contentTopInsetPx: 0,
  contentBottomInsetPx: 0,
};

export const SCREEN_STRICT_METRICS = {
  ...BASE_A4_METRICS,
  sheetGapPx: 10,
  contentTopInsetPx: 24,
  contentBottomInsetPx: 18,
};

export const PRINT_STRICT_METRICS = {
  ...BASE_A4_METRICS,
  sheetGapPx: 0,
  contentTopInsetPx: 0,
  contentBottomInsetPx: 0,
};

export const REPORT_PAGE_METRICS = SCREEN_STRICT_METRICS;

export const getMetricsForProfile = (profile = 'screen') => (
  profile === 'print' ? PRINT_STRICT_METRICS : SCREEN_STRICT_METRICS
);

export const getUsablePageHeight = (metrics = REPORT_PAGE_METRICS) => (
  Math.max(1, metrics.pageHeightPx)
);

export const clampPageNumber = (value, pageCount) => {
  const safePageCount = Math.max(1, Number(pageCount) || 1);
  const numericValue = Number(value) || 1;
  return Math.min(Math.max(1, numericValue), safePageCount);
};
